export default __webpack_public_path__ + "static/media/js-dom.711ca40d.gif";